var map = {
	"./angular-logo.png": [
		57,
		0
	],
	"./javascript-logo.png": [
		58,
		1
	],
	"./node-logo.png": [
		59,
		2
	],
	"./react-logo.png": [
		60,
		3
	],
	"./shopify-logo.png": [
		61,
		4
	],
	"./wordpress-logo.png": [
		62,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 80;
module.exports = webpackAsyncContext;